import { ESectionAlign, ESectionColor, Section } from '@web_opxp/components';
import { FirebaseSelectors } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { UnityPortal } from 'web_unity_engine';
import { ASSESSMENT_SESSION_ID } from '../../base/constants';
import { CyclesSelectors } from '../../cycles';
import { IState } from '../../store/state';
import { UnitySelectors } from '../../unity';
import { AssessmentProgress, ProgressPageState } from '../AssessmentProgress';
import * as Selectors from '../selectors';
import { AssessmentActions } from '../slice';
import {
  findWorkoutInConfig,
  getAssessmentConfigForCycle,
  getAssessmentLength,
  getWorkoutIndexFromConfig,
} from '../utils';
import './Session.scss';
import WorkoutIntro from './WorkoutIntro';

export interface IProps {
  description: string;
  hasCFQ: boolean;
  index: number;
  progress: number;
  ready: boolean;
  running: boolean;
  sessionLength: number;
  title: string;
  onStartWorkout: () => void;
}

const SessionSubpageView: React.FC<IProps> = ({
  description,
  hasCFQ,
  index,
  progress,
  ready,
  running,
  sessionLength,
  title,
  onStartWorkout,
}) => {
  const canvasId = process.env.NX_PUBLIC_UNITY_ID || 'unity';
  return (
    <>
      <Section color={ESectionColor.blue} align={ESectionAlign.center} className="session-section">
        <div className="session-frame">
          <WorkoutIntro
            description={description}
            title={title}
            show={!running}
            ready={ready}
            progress={progress}
            step={index + 1}
            max={sessionLength}
            onStartClick={onStartWorkout}
          />
          <UnityPortal canvasId={canvasId} />
        </div>
      </Section>
      <Section>
        <AssessmentProgress
          page={ProgressPageState.AssessmentSession}
          max={sessionLength}
          step={index + 1}
          cfq={hasCFQ}
        />
      </Section>
    </>
  );
};

export const mapStateToProp = (state: IState) => {
  const workoutId = Selectors.getWorkoutId(state);
  const cycleId = CyclesSelectors.getCurrentCycleId(state);
  const firebaseReady = FirebaseSelectors.isReady(state);
  let description = '';
  let title = '';
  let index = 0;
  let sessionLength = 0;
  if (firebaseReady) {
    const config = getAssessmentConfigForCycle(cycleId);
    const workout = findWorkoutInConfig(workoutId, ASSESSMENT_SESSION_ID, config);
    description = workout.description;
    title = workout.title;
    index = getWorkoutIndexFromConfig(workoutId, ASSESSMENT_SESSION_ID, config);
    sessionLength = getAssessmentLength(ASSESSMENT_SESSION_ID, config);
  }
  const unityReady = Selectors.isUnityReady(state);
  const progress = UnitySelectors.getUnityProgress(state);
  const running = Selectors.isRunning(state);
  const hasCFQ = CyclesSelectors.doesCurrentSessionHasCFQWorkouts(state);
  return {
    description,
    hasCFQ,
    index,
    progress,
    ready: unityReady && firebaseReady,
    running,
    sessionLength,
    title,
  };
};

export const mapDispatchToProps = {
  onStartWorkout: AssessmentActions.startWorkout,
};

const SessionSubpage = connect(mapStateToProp, mapDispatchToProps)(SessionSubpageView);
export default SessionSubpage;
